export default [{
  icon: 'iconqingjia',
  color: '#1890FF'
}, {
  icon: 'iconrili1',
  color: '#FF9900'
}, {
  icon: 'iconjine',
  color: '#00C050'
}, {
  icon: 'iconqianbao',
  color: '#1890FF'
}, {
  icon: 'icongouwuche',
  color: '#FF9900'
}, {
  icon: 'icona-xingzhuang2',
  color: '#1890FF'
}, {
  icon: 'icondianhua',
  color: '#FF9900'
}, {
  icon: 'icongongjiao',
  color: '#00C050'
}, {
  icon: 'iconchuanda',
  color: '#1890FF'
}, {
  icon: 'iconjiaoche',
  color: '#FF9900'
}, {
  icon: 'iconfeiji',
  color: '#1890FF'
}, {
  icon: 'iconzhangzi',
  color: '#00C050'
}, {
  icon: 'iconwenjian1',
  color: '#1890FF'
}, {
  icon: 'iconwenjianhe',
  color: '#1890FF'
}, {
  icon: 'iconwenzhang',
  color: '#FF9900'
}, {
  icon: 'iconlaba',
  color: '#00C050'
}, {
  icon: 'icongongju',
  color: '#FF9900'
}, {
  icon: 'iconbingzhuangtu',
  color: '#00C050'
}, {
  icon: 'iconshuju',
  color: '#00C050'
}, {
  icon: 'icontupian2',
  color: '#FF9900'
}, {
  icon: 'icondiannao',
  color: '#1890FF'
}, {
  icon: 'iconwenjianku',
  color: '#FF9900'
}, {
  icon: 'iconjianzhu',
  color: '#1890FF'
}, {
  icon: 'iconwendang2',
  color: '#00C050'
}, {
  icon: 'iconwendang11',
  color: '#FF9900'
}, {
  icon: 'iconyunwendang',
  color: '#1890FF'
}, {
  icon: 'icongeren',
  color: '#1890FF'
}, {
  icon: 'icondizhi',
  color: '#00C050'
}, {
  icon: 'iconxunzhang',
  color: '#1890FF'
}, {
  icon: 'iconhuojiangwenzhang',
  color: '#1890FF'
}, {
  icon: 'iconzhuanqian',
  color: '#1890FF'
}, {
  icon: 'iconliwu',
  color: '#FF9900'
}, {
  icon: 'iconjiangbei',
  color: '#1890FF'
}, {
  icon: 'iconhuangguan',
  color: '#00C050'
}, {
  icon: 'iconyoujian',
  color: '#FF9900'
}, {
  icon: 'iconliaotian',
  color: '#00C050'
}, {
  icon: 'iconri',
  color: '#1890FF'
}, {
  icon: 'iconyue',
  color: '#FF9900'
}, {
  icon: 'iconzhou',
  color: '#00C050'
}, {
  icon: 'icongouwu',
  color: '#1890FF'
}];